import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-training-blog',
  templateUrl: './online-training-blog.component.html',
  styleUrls: ['./online-training-blog.component.scss']
})
export class OnlineTrainingBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
